import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { PayrollsService } from "@/services/payrolls";
import { UpdatePayrollAggregate } from "@/types/payrollAggregate";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { usePayrollParams } from "./usePayrollParams";

export const useUpdatePayrollAggregateMutation = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { payrollId } = usePayrollParams();
  const queryClient = useQueryClient();

  return useMutationWithErrorHandling({
    errorTitle: t("payrolls.errors.split"),
    mutationFn: (entries: UpdatePayrollAggregate[]) =>
      PayrollsService.updatePayrollAggregates(entries),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.Payrolls, payrollId],
      });
      toast({
        title: t("payrolls.success.update"),
      });
    },
  });
};
